import {ROOT_NODE} from '../symbols';

export function getHoistTarget(hostVariables) {
	return hostVariables[ROOT_NODE].host;
}
